import React, { useState } from 'react';
import PendingAds from '../components/PendingAds.js';
import ReadyToLiveAds from '../components/ReadyToLiveAds.js';
import CompletedAds from '../components/CompletedAds.js';

const TAB_KEYS = ["pending_ads", "ready_to_live", "completed_ads"];
const TAB_LABELS = {
    pending_ads: "Pending Ads",
    ready_to_live: "Ready to Live",
    completed_ads: "Completed Ads"
};

const MyAds = ({adCounts}) => {
    const [activeSubTab, setActiveSubTab] = useState("pending_ads");
    
    const handleTabChange = (tabKey) => {
        setActiveSubTab(tabKey);
    };

    const renderTabButton = (key) => (
        <button
            key={key}
            onClick={() => handleTabChange(key)}
            className={`px-2 py-1 text-sm rounded-md transition ${
                activeSubTab === key
                    ? "bg-blue-600 text-white font-bold shadow"
                    : "bg-white text-gray-700 hover:bg-gray-100 border"
            }`}
        >
            {<>{TAB_LABELS[key]} <span className="text-black mx-1 py-1 px-2 bg-gray-200 rounded-full text-xs">{adCounts[key]}</span></> }
        </button>
    );

    const renderActiveComponent = () => {
        switch (activeSubTab) {
            case "pending_ads":
                return <PendingAds isActive={activeSubTab === "pending_ads"} />;
            case "ready_to_live":
                return <ReadyToLiveAds isActive={activeSubTab === "ready_to_live"} />;
            case "completed_ads":
                return <CompletedAds isActive={activeSubTab === "completed_ads"} />;
            default:
                return <PendingAds isActive={activeSubTab === "pending_ads"} />;
        }
    };

    return (
        <div>
            <div className="mb-4">
                <div className="flex gap-2">
                    {TAB_KEYS.map(renderTabButton)}
                </div>
            </div>
            <div>
                {renderActiveComponent()}
            </div>
        </div>
    );
};

export default MyAds;
